<template>
  <div>
    <Echart :options="options" id="centreLeft1Chart" height="400px" width="100%"></Echart>
  </div>
</template>

<script>
  import Echart from '@/common/echart'
  export default {
    data() {
      return {
        options: {},
      };
    },
    components: {
      Echart,
    },
    props: {
      cdata: {
       type: Array,
        default: () => ({})
      },
    },
    mounted(){
    },
    watch: {
      cdata: {
        handler(newData) {
          this.options = {
            tooltip: {
              trigger: 'item',
              formatter: "{a} <br/>{b} : {c} ({d})%",
            },
            legend: {
              top: '5%',
              left: 'center'
            },
            series: [{
              name: '省市分布',
              type: 'pie',
              radius: ['30%', '60%'],
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2
              },
              label: {
                show: false,
                position: 'center'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: '14',
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },
              data: newData,
              // itemStyle: {
              //   normal: {
              //     label: {
              //       show: true,
              //       position: 'inner',
              //       formatter: ' {c} ({d}%)'
              //     },
              //     labelLine: {
              //       show: true
              //     }
              //   }
              // }
            }]
          }
        },
        immediate: true,
        deep: true
      }
    }
  };
</script>

<style lang="scss" scoped>
</style>